import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const userRole = localStorage.getItem("userRole"); // Fetch user role from localStorage or context

  if (allowedRoles.includes(userRole)) {
    return children; // Render the component if the user role is allowed
  }

  return <Navigate to="/" replace />; // Redirect to home page if not authorized
};

export default ProtectedRoute;
